import {
  Box,
  Button,
  Checkbox,
  Container,
  FormControl,
  HStack,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  Link,
  Stack,
  Text,
  Center,
  useDisclosure,
} from "@chakra-ui/react";
import { PasswordField } from "./components/PasswordField";
import { Logo } from "./components/Logo";
import { useEffect, useState } from "react";
import { FaUser } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "../../components/PrimaryButton";
import { useDispatch, useSelector } from "react-redux";
import { loginRequest, verifyOTPRequest } from "./authStore/actions";
import ErrorAlert from "../../components/ErrorAlert";
import OtpModal from "./components/OtpModal";
import LoadingSpinner from "../../components/LoadingSpinner";
import validator from "validator";

export const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loginError, setLoginError] = useState(false);
  const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);

  const { is_logged_in, error, loading, token } = useSelector(
    (state) => state.auth
  );

  // useEffect(() => {
  //   const authUser = JSON.parse(localStorage.getItem("user"));
  //   if (authUser) {
  //     navigate("/h/home");
  //   }
  // }, [navigate]);

  useEffect(() => {
    if (is_logged_in) {
      onOpen();
      setIsOtpModalOpen(true);
    }
  }, [is_logged_in]);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [!isOtpModalOpen, username, password]);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      if (isOtpModalOpen) {
        return;
      } else {
        event.preventDefault();
        onSubmit();
      }
    }
  };

  useEffect(() => {
    if (error) setLoginError(error.message);
  }, [error]);

  const onSubmit = () => {
    if (!isOtpModalOpen) {
      if (username === "") {
        setLoginError("Please enter email");
        return;
      } else if (!validator.isEmail(username)) {
        setLoginError("Please enter valid Email address");
        return;
      } else if (password === "") {
        setLoginError("Please enter password");
        return;
      }

      let payload = {
        usr: username,
        pwd: password,
        user_type: "HCF",
        source: "Web",
      };
      dispatch(loginRequest(payload));
    }
  };

  const handleOtpSubmit = (otp) => {
    let payload = {
      usr: username,
      otp: otp,
      otp_type: "Login",
      token: token,
      navigate: navigate,
      redirectPath: "/h/home",
    };
    dispatch(verifyOTPRequest(payload));
  };

  return (
    <Center minHeight="100vh" alignItems="center" justifyContent="center">
      {loading && <LoadingSpinner />}
      <Container
        maxW="lg"
        py={{ base: "12", md: "24" }}
        px={{ base: "0", sm: "8" }}
      >
        <Stack spacing="8">
          <Box
            py={{ base: "0", sm: "8" }}
            px={{ base: "4", sm: "10" }}
            bg={{ base: "transparent", sm: "bg.surface" }}
            // boxShadow={{ base: 'none', sm: 'lg' }}
            boxShadow="5px 5px 30px 0px rgb(224 222 222 / 89%)"
            borderRadius={{ base: "none", sm: "xl" }}
          >
            <Stack spacing="6">
              <Stack spacing="0">
                <Logo />
                {/* <Stack spacing="0" textAlign="center">
                  <BrandedHeading fontWeight="700">Login</BrandedHeading>
                </Stack> */}
              </Stack>
              <Stack spacing="6">
                <Stack spacing="5">
                  <FormControl>
                    {/* <FormLabel htmlFor="email">Email</FormLabel> */}
                    <InputGroup>
                      <InputLeftElement>
                        <IconButton
                          variant="text"
                          aria-label={"Email"}
                          icon={<FaUser />}
                          tabIndex={-1}
                        />
                      </InputLeftElement>
                      <Input
                        placeholder="Enter your email"
                        id="email"
                        name="email"
                        type="email"
                        onChange={(e) => {
                          setUsername(e.target.value);
                          setLoginError(false);
                        }}
                        required
                      />
                    </InputGroup>
                  </FormControl>
                  <PasswordField
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                      setLoginError(false);
                    }}
                  />
                </Stack>
                <HStack justify="end">
                  {/* <Checkbox defaultChecked>Remember me</Checkbox> */}
                  {/* <Checkbox
                    isChecked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                  >
                    Remember me
                  </Checkbox> */}
                  <Button
                    variant="text"
                    color="grey.1"
                    onClick={(e) => navigate("/forgot-password")}
                  >
                    Forgot password?
                  </Button>
                </HStack>
                <Stack spacing="6">
                  {loginError && <ErrorAlert message={loginError} />}
                  <PrimaryButton
                    onClick={onSubmit}
                    // isLoading={isLoading}
                    loadingText="Login"
                    colorScheme="teal"
                    variant="outline"
                    spinnerPlacement="end"
                  >
                    Login
                  </PrimaryButton>
                  <Stack spacing={{ base: "2", md: "3" }} textAlign="center">
                    <Text color="fg.muted">
                      Don't have an account?{" "}
                      <Link href="/register" style={{ color: "#57ACFF" }}>
                        Register Here
                      </Link>
                    </Text>
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
          </Box>
        </Stack>
      </Container>
      <OtpModal
        isOpen={isOpen}
        // onClose={onClose}
        onClose={() => {
          setIsOtpModalOpen(false);
          onClose();
        }}
        onSubmit={handleOtpSubmit}
        user={username}
        otpType="Login"
      />
    </Center>
  );
};
